import styled from 'styled-components';

const H4 = styled.h4`
  display: inline-block;
  margin: 0;
`;

export default H4;
